import React from "react";
import { ycCompanies } from "assets/ycCompanies";
import RecruiterClientItem from "./RecruiterClientItem";

const headerColumns = {
  companyName: {
    name: "Company",
    width: "35%",
  },
  clientId: {
    name: "Client ID",
    width: "10%",
  },
  clientUsername: {
    name: "Client Username",
    width: "25%",
  },
  numOrders: {
    name: "Orders",
    width: "10%",
  },
  lastActive: {
    name: "Last Active",
    width: "20%",
  },
};

export default function RecruiterClientsPageTable() {
  return (
    <table className="w-full text-sm text-left">
      <thead className="text text-gray-800 bg-gray-59">
        <tr>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.companyName.width }}>
            {headerColumns.companyName.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.clientId.width }}>
            {headerColumns.clientId.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.clientUsername.width }}>
            {headerColumns.clientUsername.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.numOrders.width }}>
            {headerColumns.numOrders.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.lastActive.width }}>
            {headerColumns.lastActive.name}
          </th>
        </tr>
      </thead>
      <tbody>
        {ycCompanies.map((company) => (
          <RecruiterClientItem company={company} />
        ))}
      </tbody>
    </table>
  );
}
